import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogInputItem from './item.js';

class Component extends BaseComponent {
    render({ input }) {
        return (
            <catalog-input>
                <h5>
                    Filter by {input.name}{this.renderCount(input.count)}
                    <img src='https://gfx.tarot.com/images/catalog/update/catalog-arrow.svg' alt='white down arrow' />
                </h5>
                {input.items.map(item => (<CatalogInputItem item={item} callback={this.update} />))}
            </catalog-input>
        );
    }

    renderCount(count) {
        if (count) {
            return (<span>( {count} )</span>);
        }

        return null;
    }

    update = () => {
        const count = this.props.input.items.reduce((total, item) => {
            if (item.checked) {
                total++;
            }

            return total;
        }, 0);

        this.setState({count: count});
    }
}

export default connect()(Component);
